module.exports = __webpack_public_path__ + "src/assets/img/1240x648_twichend.9bbb235f.jpg";